"use strict";

exports.__esModule = true;
exports.AdvancedTimelineLabelSelector = AdvancedTimelineLabelSelector;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _AdvancedTimelineContext = require("./AdvancedTimelineContext");
var _Selector = require("../../Core/Selector");
var _Translator = require("../../Core/Translator");
var _SelectorOption = require("./SelectorOption");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function placeholder(translate) {
  return translate("AdvancedTimelineFields.DimensionSelector.label", "Select Labels");
}
function AdvancedTimelineLabelSelector(props) {
  var timelines = _react["default"].useContext(_AdvancedTimelineContext.AdvancedTimelineContext);
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var elementEditor = props.elementEditor,
    path = props.path,
    element = props.element;
  var selectedTimeline = timelines.find(function (timeline) {
    return timeline.type === element.props.timeline;
  });
  if (!selectedTimeline) {
    return null;
  }
  var labels = selectedTimeline.fields.filter(function (field) {
    return new RegExp("dimension.", "gi").test(field);
  }).filter(function (field) {
    return !!field;
  });
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: placeholder(translate)
  }, /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
    multiple: true,
    items: labels,
    getKey: function getKey(dimension) {
      return dimension;
    },
    selected: element.props.labels ? element.props.labels : [],
    onSelect: function onSelect(selectedDimensions) {
      return elementEditor.setProp(path, "labels", selectedDimensions);
    },
    renderItemText: function renderItemText(dimension) {
      return /*#__PURE__*/_react["default"].createElement(_SelectorOption.SelectorOption, {
        parentComponent: "AdvancedTimelineLabelSelector",
        value: selectedTimeline.fieldLabels[dimension]
      });
    },
    placeholder: placeholder(translate),
    width: 275
  }));
}